// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import atowsEntity from './entities/atows.json';
import atowsMenu from '../pages/atows/menu.json';
import atowsFullForm from '../pages/atows/forms/full.json';
import atowsContextForm from '../pages/atows/forms/context.json';
import atowsMiniForm from '../pages/atows/forms/mini.json';
import atowsLookupForm from '../pages/atows/forms/lookup.json';
import atowsTableView from '../pages/atows/views/table.json';
import atowsStagesView from '../pages/atows/views/stages.json';
import atowsCardsView from '../pages/atows/views/cards.json';
import atowsInlineView from '../pages/atows/views/inline.json';
import atowsBacklogView from '../pages/atows/views/backlog.json';
import atowsSplitView from '../pages/atows/views/split.json';
import atowsCalendarView from '../pages/atows/views/calendar.json';
import atowsDashboardView from '../pages/atows/views/dashboard.json';

/** Тип запису «Стратегія TOWS» зі сторінками пакета: меню, форми та подання з pages/atows/. */
export const atowsDefinition: IRecordTypeDefinition = {
  ...atowsEntity,
  views: assembleViewSet({
      table: atowsTableView,
      stages: atowsStagesView,
      cards: atowsCardsView,
      inline: atowsInlineView,
      backlog: atowsBacklogView,
      split: atowsSplitView,
      calendar: atowsCalendarView,
      dashboard: atowsDashboardView,
  }),
  form: atowsFullForm,
  forms: { full: atowsFullForm, context: atowsContextForm, mini: atowsMiniForm, lookup: atowsLookupForm },
  menu: atowsMenu,
} as IRecordTypeDefinition;
